import { Edit, Eye, Trash } from "tabler-icons-react";

export const lookupListHeaders = [
  { id: "id", numeric: true, disablePadding: true, label: "ID" },

  //give full width to the question column
  {
    id: "lookupType",
    numeric: false,
    disablePadding: true,
    label: "lookupType",
  },
  {
    id: "lookupName",
    numeric: false,
    disablePadding: true,
    label: "lookupName",
  },

  // {
  //   id: "state",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Status",
  // },
  // {
  //   id: "createdDate",
  //   date: true,
  //   numeric: false,
  //   disablePadding: true,
  //   label: "createdDate",
  // },
  {
    id: "actions",
    view: <Eye />,
    edit: <Edit />,
    delete: <Trash />,
    numeric: false,
    label: "Actions",
  },
];
